<template>
<tr :id="'searchTableRow-row-'+ customerObj.uniqueId">

  <td class="font-weight-bold" :id="'searchTableRow-data-'+ customerObj.uniqueId">
    <router-link :to="'/customer/' + customerObj.uniqueId" :id="'searchTableRow-link-'+ customerObj.uniqueId">
      {{ customerObj.uniqueId }}
    </router-link>
  </td>

  <td>{{ customerObj.name }}</td>

  <td>{{ customerObj.batchId }}</td>

  <td :id="'searchTableRow-crmData-'+ customerObj.uniqueId">
    <a v-if="customerObj.crmLink" :href="customerObj.crmLink" target="_blank" class="small font-weight-bold" :id="'searchTableRow-crmLink-'+ customerObj.uniqueId">
      <i class="fa fa-external-link mr-1" aria-hidden="true"></i>
      {{ customerObj.crmLink }}
    </a>
  </td>

</tr>
</template>

<script>
export default {
  props: ['customerObj']
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/customers/SearchTableRow.vue